import { createContext } from 'react';
const MenuContext = createContext({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false,
    styles: null,
    classNames: null,
});
export default MenuContext;
